import React from "react"
import { Link } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"
import ImageHome from "@components/MockableImages"
import { trackDataLayerEvent } from "@utils/trackDataLayerEvent"

const Card = ({
  img,
  text_key,
  url,
  classes,
  dataEvent = {
    id: "Case Studies All",
    triggers: "LearnMore",
    source: "Homepage",
  },
}) => {
  const { t } = useTranslation()

  const handleClick = event => {
    try {
      trackDataLayerEvent(dataEvent)
    } catch (Any) {
      console.log(Any)
    }
  }

  return (
    <div
      className={`
        bg-[white]
        w-[327px]
        flex
        flex-col
 
        md:w-[320px]
        md:h-[280px]

        desk:w-[532px]
        desk:h-[415px]
        
        ${classes?.container}
  `}
    >
      <div
        className={`
        h-[120px]
        
        md:h-[140px]
      

        desk:h-[200px]
    `}
      >
        <ImageHome image={img} />
      </div>
      <div
        className={`
        p-[20px]
        h-[100%]
        flex
        flex-col
        justify-between

        desk:p-[32px]
        `}
      >
        <div>
          <p
            className={`
        text-left
        font-inter
        text-[#151124]
        text-[16px]
        font-medium
        leading-[130%]
      
        desk:text-[24px]
        desk:leading-[140%]
        `}
          >
            {t(text_key)}
          </p>
        </div>
        <div
          className={`
        text-right
        
        mt-[8px]

        md:mt-0
        `}
          onClick={handleClick}
        >
          <Link
            to={url}
            className={`     
        font-inter
        text-[#3759F0]
        text-[14px]
        font-medium
        leading-[150%]
        tracking-[0.14px]
        underline
       
        desk:text-[18px]
        desk:leading-[140%]
        `}
          >
            <span className="sr-only">{t(text_key)}-: </span>
            {t("Home_Button3")}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Card
